import { useTranslation } from "react-i18next";
import EnglishIcon from "src/images/english.png";
import Portugal from "src/images/portugal.png";
import Spanish from "src/images/spanish.png";
import axiosInstance from "src/utils/axios";

import { useEffect, useState } from "react";

const LANGS = [
  {
    label: "English",
    value: "en",
    icon: "/assets/icons/flags/ic_flag_en.svg",
  },
  {
    label: "Spanish",
    value: "es",
    icon: "/assets/icons/flags/ic_flag_sp.svg",
  },
  {
    label: "Portuguese",
    value: "pt",
    icon: "/assets/icons/flags/ic_flag_pt.svg",
  },
  // {
  //   label: "German",
  //   value: "de",
  //   icon: "/assets/icons/flags/ic_flag_de.svg",
  // },
  // {
  //   label: "Japanese",
  //   value: "ja",
  //   icon: "/assets/icons/flags/ic_flag_jp.svg",
  // },
  {
    label: "Italian",
    value: "it",
    icon: "/assets/icons/flags/ic_flag_ity.svg",
  },
];
export default function useLocales() {
  const { i18n, t: translate } = useTranslation();
  const [currentLang, setCurrentLang] = useState(() => {
    const langStorage = localStorage.getItem("i18nextLng");
    if (langStorage) {
      const selectedLanguage = LANGS.find(
        (_lang) => _lang.value === langStorage
      );
      if (selectedLanguage) {
        return selectedLanguage;
      }
    }
    return LANGS[0];
  });

  const handleChangeLanguage = (newlang) => {
    i18n.changeLanguage(newlang);

    // Fase 2 Shop: persisti la lingua sul server (users.language) cosi' i filtri
    // prodotto per "mercato" valgono come in app (it = Italia, qualsiasi altra
    // lingua = Resto del mondo). Solo se loggato. Poi reload per rifare il fetch
    // prodotti col mercato aggiornato (il lock e' calcolato lato server).
    const token = localStorage.getItem("accessToken");
    if (!token) return;
    const serverLang = newlang === "it" ? "it" : "en";
    axiosInstance
      .post(
        "/api/app/language",
        { language: serverLang },
        { headers: { "Content-Type": "application/json" } }
      )
      .catch(() => {})
      .finally(() => {
        window.location.reload();
      });
  };

  // Set initial language from localStorage on mount
  useEffect(() => {
    const langStorage = localStorage.getItem("i18nextLng");
    if (langStorage && i18n.language !== langStorage) {
      i18n.changeLanguage(langStorage);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("i18nextLng", i18n.language);
    const selectedLanguage = LANGS.find(
      (_lang) => _lang.value === i18n.language
    );
    setCurrentLang(selectedLanguage);
  }, [i18n.language]);
  return {
    onChangeLang: handleChangeLanguage,
    translate,
    currentLang,
    allLang: LANGS,
  };
}
